<template>
  <v-card class="teros-elevation" :color="tableColor">
    <v-card-title class="px-5 pb-0 v-title-cadastro">
      <span class="h5 font-weight-bold">
        Projeto: <span class="">{{ projeto.titulo }}</span>
      </span>
    </v-card-title>

    <MasterDetail
      ref="masterDetail"
      class="master-detail"
      formTitle="Cadastro demais dispêndios"
      :hasExportCSV="false"
      :hasExportXLSX="false"
      :opts="opts"
      :cols="cols"
      :canEdit="false"
      :canDelete="true"
      :hasNewButton="false"
      :hasDayFilter="true"
      :actionBarButtons="actionBarButtons"
      :contextOptions="contextOptions"
      :customResource="customResource"
      :selection.sync="selection"
      :selectionCol="true"
    >
      <DropdownCaptacao />
      <QueueDialog
        :opened.sync="isVisibleQueueDialog"
        title="Exportação de despesas"
        appendTitleIcon="mdi-file-chart-outline"
      ></QueueDialog>

      <GModal
        :opened.sync="isVisibleModalWarning"
        width="550px"
      >        
        <p>Não foi possível atualizar: <b style="color: red">a seleção de dispêndios contém mais de um tipo de rubrica.</b></p>
        <p><b>Para continuar, filtre os dispêndios por um único tipo de rubrica</b> e então aplique a atualização em lote.</p>
      </GModal>

      <FormModal
        title="Atualização dispêndios"
        :opened.sync="isVisibleModalUpdateMultiple"
        :value.sync="modalUpdateMutipleValue"
        :cols="colsPareamentoLote"
        :opts="opts"
        @save="doUpdateMultipleConfirm"
      >        
      </FormModal>
    </MasterDetail>
  </v-card>
</template>

<script>
import MasterDetail from "@/components/master-detail.vue";
import { cloneDeep } from 'lodash';
import { mapGetters } from "vuex";

const tipoRubricasCamposAdicionaisEnum = ["Viagens e Diárias"];

export default {
  components: {
    MasterDetail,
    DropdownCaptacao: () => import("@/components/dropdown-captacao.vue"),
    QueueDialog: () => import("@/components/queue-dialog.vue"),
    GModal: () => import("@/components/g-modal.vue"),
    FormModal: () => import("@/components/form-modal.vue"),
  },
  data() {
    return {
      opts: {
        rubricas: [],
        documentos: [],
        projetos: [],
        fornecedores: [],
        descricaoRubricas: [],
        contrapartidas: [
          {
            id: "0",
            value: "Não"
          },
          {
            id: "1",
            value: "Sim"
          }
        ],
        equipesViagensEDiarias: [
          {
            id: 1,
            value: "Não"
          },
          {
            id: 2,
            value: "Sim"
          }
        ],
        tipoDespesasViagensEDiarias: [
          {
            id: 1,
            tipo: "Alimentação"
          },
          {
            id: 2,
            tipo: "Passagem"
          },
          {
            id: 3,
            tipo: "Diária"
          },
          {
            id: 4,
            tipo: "Deslocamento"
          }
        ],
        pareamentoSelecao: [],
      },
      formModalOpen: false,
      formModalValue: {},
      isDescricaoEditable: false,
      isVisibleNewFornecedorData: false,
      isVisibleViagensDiarias: false,
      projeto: {
        titulo: ""
      },
      isVisibleQueueDialog: false,
      selection: [],
      isVisibleModalWarning: false,
      isVisibleModalUpdateMultiple: false,
      modalUpdateMutipleValue: {},
    };
  },
  computed: {
    ...mapGetters(["clientId", "intervaloData"]),
    actionBarButtons() {
      const actionBarButtons = [];
      const that = this;
      actionBarButtons.push(
        {
          text: "Adicionar",
          icon: "mdi-plus-box-outline",
          show: true,
          action() {
            that.$router.push({
              name: "cadastro-demais-dispendios",
              params: { id: that.projetoId }
            });
          }
        },
        {
          text: "Atualização em lote",
          icon: "mdi-file-document-multiple-outline",
          show: that.selection.length > 0,
          async action() {
            if(that.isSelecaoRubricasValida()) {
              await that.getSelecaoPareamentos();
              that.isVisibleModalUpdateMultiple = true;
            }
          }
        },
        {
          text: "Exportação assíncrona",
          icon: "mdi-cloud-refresh-outline",
          show: true,
          async action() {
            await that.exportacao();
          }
        },
      );

      return actionBarButtons.filter(({ show }) => show);
    },
    contextOptions() {
      const that = this;
      const contextOptions = [
        {
          name: "Editar",
          show: true,
          cb(row) {
            that.$router.push({
              name: "edicao-demais-dispendios",
              params: { id: that.projetoId, dispendio: row.id }
            });
          }
        },
        {
          name: "Duplicar",
          show: true,
          cb(row) {
            that.doDuplicate(row);
          }
        },
        {
          name: "Atualização em lote",
          show: that.selection.length > 0,
          async cb() {
            if(that.isSelecaoRubricasValida()) {          
              await that.getSelecaoPareamentos();               
              that.isVisibleModalUpdateMultiple = true;   
            }      
          }
        }
      ];

      return contextOptions.filter(({ show }) => show);
    },
    cols() {
      return [
        {
          key: "id",
          hideInTable: true,
          hideInform: true,
        },
        {
          key: "projeto_id",
          hideInTable: true,
          hideInform: true,
        },
        {
          key: "rubrica_id",
          hideInTable: true,
          hideInform: true,          
        },
        {
          key: "pareamento_id",
          hideInTable: true,
          hideInform: true,
        },
        {
          key: "documento_id",                    
          hideInTable: true,
          hideInform: true,
        },        
        {
          key: "fornecedor",
          name: "Fornecedor",
          type: this.$fieldTypes.TEXT,     
          hideInTable: true,
          hideInform: true,     
        },
        {
          key: "aquisicao",
          name: "Aquisição",
          type: this.$fieldTypes.TEXT,          
        },
        {
          key: "rubrica",
          name: "Rubrica",
          type: this.$fieldTypes.TEXT,
          filterable: true,   
        },
        {
          key: "descricao",
          name: "Descrição do dispêndio",
          type: this.$fieldTypes.TEXT,
          filterable: true,          
        },
        {
          key: "descricao_produto",
          name: "Descrição do produto",
          type: this.$fieldTypes.TEXT,          
        },
        {
          key: "fornecedor_razao",
          name: "Fornecedor",
          type: this.$fieldTypes.TEXT,
          filterable: true,          
        },
        {
          key: "fornecedor_cnpj",
          name: "CNPJ/CPF",
          type: this.$fieldTypes.CNPJ,     
          width: '150px',     
        },
        {
          key: "documento",
          name: "Tipo do documento",
          type: this.$fieldTypes.TEXT,
          colSize: 3
        },
        {
          key: "nro_documento",
          name: "Nº Documento",
          type: this.$fieldTypes.TEXT,
          colSize: 3,
          filterable: true,
        },
        {
          key: "data_emissao",
          name: "Data de emissão",
          type: this.$fieldTypes.DATE,
          colSize: 3,
          rules: [{ rule: "required" }]
        },
        {
          key: "valor",
          name: "Valor realizado",
          type: this.$fieldTypes.MONEY,
          colSize: 3,
          width: "150px"
        },
        {
          key: "job_id",
          name: "ID Importação",
          type: this.$fieldTypes.TEXT,
          filterable: true,
        },
        {
          key: "data_pagamento",
          name: "Data Pagamento",
          type: this.$fieldTypes.DATE,
          hideInTable: true,
          hideInform: true,
          colSize: 3
        },
        {
          key: "contrapartida",
          name: "Contrapartida",
          colSize: 4,
          hideInTable: true,
          hideInform: true,
          type: this.$fieldTypes.SWITCH,
          rel: {
            toEdit: [
              { id: 0, nome: "Não" },
              { id: 1, nome: "Sim" }
            ],
            key: "id",
            name: "nome"
          }
        },
        {
          key: "contrapartida",
          name: "Contrapartida",
          colSize: 4,
          hideInTable: true,
          hideInform: true,
          type: this.$fieldTypes.SELECT,
          rel: { to: "contrapartidas", key: "id", name: "value" }
        }
      ];
    },
    projetoTitle() {
      return this.$route.params.projeto?.titulo;
    },
    projetoId() {
      return this.$route.params.id;
    },
    customResource() {
      const resource = this.apiResource(
        `/v1/captacao/${this.clientId}/dispendios/${this.projetoId}`
      );
      return {
        ...resource,
        get(...params) {
          return resource.get(...params).then(result => {
            return result;
          });
        },        
      };
    },
    colsPareamentoLote() {
      return [
        {
          key: 'id',
          name: 'Pareamento',
          type: this.$fieldTypes.SELECT,
          rules: [{ rule: "required" }],
          rel: { to: 'pareamentoSelecao', key: 'id', name: 'descricao'},
        }
      ]
    }
  },
  created() {
    this.getProjetoSelecionado();    
  },
  methods: {
    updateRubricaDescricao(rubricaId) {
      if (!rubricaId) return (this.isDescricaoEditable = false);
      const rubricaSelecionada = this.opts.rubricas.filter(rubrica => {
        return rubrica.id == rubricaId;
      })[0];
      if (rubricaSelecionada.tipo == tipoRubricasCamposAdicionaisEnum[0])
        this.isVisibleViagensDiarias = true;
      const that = this;
      const resource = this.apiResource(
        `/v1/captacao/${this.clientId}/rubricas/pareamento/${this.projetoId}/${rubricaId}`
      );
      return resource.get().then(descricoes => {
        that.opts.descricaoRubricas = descricoes || [];
        this.isDescricaoEditable = true;
        return descricoes;
      });
    },
    getProjetoSelecionado() {
      return this.apiResource(
        `/v1/captacao/projetos/${this.clientId}/${this.projetoId}`
      )
        .get()
        .then(result => {
          return (this.projeto = result);
        });
    },
    async doDuplicate(data) {
      if (!data) {
        return;
      }

      try {
        const body = cloneDeep(data);
        delete body.criado_em;
        delete body.id;
        delete body.modificado_em;
        delete body.job_id;

        const resource = this.apiResource(
          `/v1/captacao/${this.clientId}/dispendios/${this.projetoId}`
        );
        await resource.save(body);
        this.$notify({
          group: "geral",
          duration: 5000,
          type: "success",
          title: "Duplicado com sucesso.",
          text: "Registro foi duplicado com sucesso.",
        });
        this.$refs.masterDetail.doLoad();
      } catch (error) {
        this.notify(error);
      }
    },
    async exportacao() {
      const that = this;
      this.apiResource(`v1/clientes/${this.clientId}/exportacao`).save({
        "tipoRelatorio": 'captacao-demais-dispendios',
        "competenciaIni": this.intervaloData[0],
        "competenciaFim": this.intervaloData[1],
        "projetoId": this.projetoId
      }).then((result) => {
        that.isVisibleQueueDialog = true;
        return result;
      })
    },
    async getSelecaoPareamentos() {
      this.$root.$emit('addLoadingProcess', 'getSelecaoPareamentos');      
      const rubricaId = await this.selection.map(async (item) => item.rubrica_id)[0];
      const response = await this.api().get(`v1/captacao/${this.clientId}/dispendios/${this.projetoId}/multiple/${rubricaId}/selecao`);
      if(response) {
        this.opts.pareamentoSelecao = response.data;
      }
      this.$root.$emit('removeLoadingProcess', 'getSelecaoPareamentos');
    },
    isSelecaoRubricasValida() {
      let rubricasAdicionadas = new Map();

      this.selection.map((item) => {
        if(!rubricasAdicionadas.has(item.rubrica_id)) {
          rubricasAdicionadas.set(item.rubrica_id);
        }
      });

      if(rubricasAdicionadas.size > 1) {      
        this.isVisibleModalWarning = true;
        this.selection = [];
        return false;
      }
      
      return true;
    },
    updateMultipleData() {
      const dispendios = this.selection.map((item) => item.id);      
      return {
        "dispendio_ids": dispendios,
        "pareamento_id": this.modalUpdateMutipleValue.id,
      }
    },
    doUpdateMultipleConfirm() {
      this.showConfirm(
        "Cuidado! Esta ação não pode ser desfeita!",
        `Ao confirmar, <b>todos os dispêndios selecionados</b> receberão a mesma <b>descrição e finalidade.</b>`,
        () => {
          this.doUpdateMultiple();
        }
      );
    },
    async doUpdateMultiple() {
      try {
        this.$root.$emit('addLoadingProcess', 'savePareamentosMultiple');
        const url = `v1/captacao/${this.clientId}/dispendios/${this.projetoId}/multiple`;
        const dados = this.updateMultipleData();
        const response = await this.api().post(url, dados);

        if(response.status === 200) {
          this.$notify({
            group: 'geral',
            title: 'Sucesso',
            type: 'success',
            text: response.data.message,
            duration: 5000
          });
        }
      } catch(e) {
        this.$notify({
          group: 'geral',
          title: 'Erro !',
          type: 'error',
          text: e.message,
          duration: 5000
        });
      } finally {
        this.$root.$emit('removeLoadingProcess', 'savePareamentosMultiple');
      }

      this.resetDataMultiple();
      this.$refs.masterDetail.doLoad();      
    },
    resetDataMultiple() {
      this.selection = [];
      this.modalUpdateMutipleValue = {},
      this.isVisibleModalUpdateMultiple = false;
    }
  },
  watch: {
    clientId() {
      this.$router.push({ name: "projetos-captacao" });
    }
  }
};
</script>

<style lang="scss" scoped>
.master-detail::v-deep .v-data-table__wrapper {
  height: calc(-290px + 100vh) !important;
}
</style>
